// Module
var code = "<md-calendar ng-model=\"panel.date\" ng-model-options=\"{timezone: panel.timeZoneOffset}\" md-min-date=\"panel.minDate\" md-max-date=\"panel.maxDate\" md-date-filter=\"panel.dateFilter\"> </md-calendar> ";
// Exports
module.exports = code;